$(document).ready(function() {

	$('.project-gallery__slider').lightGallery({
		thumbnail: true,
		animateThumb: false,
		showThumbByDefault: false,
		selector: '.proj-gall-item'
	});

	$('.project-gallery__slider').slick({
		infinite: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		rtl: ($("html").attr('dir') == 'rtl' ? true : false),
		dots: false,
		speed: 500,
		arrows: true,
		autoplay: true,
		autoplaySpeed: 5000,
		cssEase: 'linear',
		pauseOnHover: false,
		appendArrows: $(".project-gallery__slider"),
		prevArrow: $(".arr-right"),
		nextArrow: $(".arr-left"),
		responsive: [{
				breakpoint: 1550,
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 993,
				settings: {
					slidesToShow: 2,
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
				}
			},
		]
	});

});